import { faArrowDown, faArrowUp } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Avatar } from '@pickleballinc/ui/components/ui/avatar';
import clsx from 'clsx';

interface PlayerLiveRatingCardProps {
  age: number;
  gender: string;
  location: string;
  name: string;
  urlImage: string;
  firstMetric: number;
  secondMetric: number;
  thirdMetric: number;
}

export const PlayerLiveRatingCard = ({
  age,
  gender,
  location,
  name,
  urlImage,
  firstMetric,
  secondMetric,
  thirdMetric,
}: PlayerLiveRatingCardProps) => {
  return (
    <div className='flex flex-col gap-4'>
      {/* Player Information */}
      <div className='flex items-center gap-3'>
        <Avatar name={name} src={urlImage || undefined} variant='gray' />
        <div className='flex flex-col font-medium'>
          <h3 className='text-base leading-normal text-blue-600'>{name}</h3>
          <p className='text-sm text-gray-500'>
            {[age, gender, location]
              .filter((v) => (typeof v === 'number' && v <= 0 ? false : !!v))
              .join(' | ')}
          </p>
        </div>
      </div>

      {/* Metrics Display */}
      <div className='flex'>
        <div className='flex-1 rounded-lg bg-gray-100 px-4 py-2 text-center text-gray-700 md:px-2'>
          {firstMetric.toFixed(3)}
        </div>
        <div
          className={clsx('flex-1 rounded-lg px-4 py-2 text-center md:px-2', {
            'text-green-light-700': secondMetric > 0,
            'text-darkorange-700': secondMetric < 0,
          })}
        >
          <div className='flex flex-row items-center justify-center'>
            {Number(secondMetric.toFixed(3)) !== 0
              ? Number(secondMetric.toFixed(3)) < 0
                ? secondMetric.toFixed(3)
                : `+${secondMetric.toFixed(3)}`
              : ``}

            {Number(secondMetric.toFixed(3)) !== 0 && Number(secondMetric.toFixed(3)) < 0 && (
              <FontAwesomeIcon icon={faArrowDown} className='ml-2' />
            )}
            {Number(secondMetric.toFixed(3)) !== 0 && Number(secondMetric.toFixed(3)) > 0 && (
              <FontAwesomeIcon icon={faArrowUp} className='ml-2' />
            )}
          </div>
        </div>

        <div
          className={clsx('flex-1 rounded-lg px-4 py-2 text-center md:px-2', {
            'bg-green-light-100 text-green-light-700': secondMetric >= 0,
            'bg-darkorange-100 text-darkorange-700': secondMetric < 0,
          })}
        >
          {thirdMetric.toFixed(3)}
        </div>
      </div>
    </div>
  );
};
